export default "__VITE_ASSET__Cjp9H4FS__ 288w, __VITE_ASSET__mu3V_0iF__ 432w, __VITE_ASSET__B2uHY0eZ__ 576w";